import {
  PartnersListItemEcosystemResponseDto,
  PartnersListItemResponseV2Dto,
  ResultPaginationResponseDto,
} from '@tiendanube/common';
import { cirrusApi, infinityBehavior, tableBehavior } from 'App/rtk';
import { GenericParamsType } from 'commons/types';
import { UsersEndpoints, UsersTags } from './types';
import {
  BASE_USERS_PARTNERS_V2,
  PARTNER_ADMIN_ACCESS,
  UNLINK_PARTNERS_V2,
} from './urls';

export const partnersApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [
      UsersTags.partnersList,
      UsersTags.partnerAdminAccess,
      UsersTags.partnersListInf,
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [UsersEndpoints.getPartnersList]: builder.query<
        ResultPaginationResponseDto<PartnersListItemResponseV2Dto[]>,
        GenericParamsType
      >({
        query: (params) => ({
          method: 'GET',
          url: BASE_USERS_PARTNERS_V2,
          params,
        }),
        ...tableBehavior(UsersEndpoints.getPartnersList),
        providesTags: [UsersTags.partnersList],
      }),
      [UsersEndpoints.getPartnersListInf]: builder.query<
        ResultPaginationResponseDto<PartnersListItemResponseV2Dto[]>,
        GenericParamsType
      >({
        query: (params) => ({
          method: 'GET',
          url: BASE_USERS_PARTNERS_V2,
          params,
        }),
        ...infinityBehavior(UsersEndpoints.getPartnersListInf),
        providesTags: [UsersTags.partnersList],
      }),
      [UsersEndpoints.unlinkPartner]: builder.mutation<
        boolean,
        { partnerId: number; permissionId: number }
      >({
        query: ({ partnerId, permissionId }) => ({
          method: 'PUT',
          url: UNLINK_PARTNERS_V2,
          data: { partnerId, permissionId },
        }),
        invalidatesTags: (_, error) =>
          error ? [] : [UsersTags.partnersList, UsersTags.partnersListInf],
      }),
      [UsersEndpoints.getPartnerAdminAccess]: builder.query<
        PartnersListItemEcosystemResponseDto,
        void
      >({
        query: () => ({
          method: 'GET',
          url: PARTNER_ADMIN_ACCESS,
        }),
        providesTags: [UsersTags.partnerAdminAccess],
      }),
      [UsersEndpoints.updatePartnerAdminAccess]: builder.mutation<
        boolean,
        {
          payload: {
            data: Partial<{
              permissionId: number;
              partnerId: number;
              status: boolean;
            }>;
          };
        }
      >({
        query: (payload) => ({
          method: 'PATCH',
          url: PARTNER_ADMIN_ACCESS,
          data: payload,
        }),
        invalidatesTags: (_, error) =>
          error
            ? []
            : [
                UsersTags.partnerAdminAccess,
                UsersTags.partnersList,
                UsersTags.partnersListInf,
              ],
      }),
    }),
  });

export const {
  useGetPartnersListQuery,
  useUnlinkPartnerMutation,
  useGetPartnersListInfQuery,
  useGetPartnerAdminAccessQuery,
  useUpdatePartnerAdminAccessMutation,
} = partnersApi;
